import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';

import { IInstituicaoFinanceira } from '@app/modules/instituicoes-financeiras/model/instituicao.model';
import { InstituicaoFinanceiraService } from '@app/modules/instituicoes-financeiras/services/instituicao.service';
import { validateCnpj } from '@app/shared/utils';

@Component({
  selector: 'app-fast-instituicao',
  templateUrl: './fast-instituicao.component.html',
  styleUrls: ['./fast-instituicao.component.scss'],
  providers: [InstituicaoFinanceiraService]
})
export class FastInstituicaoComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  displayMessages = {
    cnpj: {
      repeated: 'Informação já cadastrada.',
      mask: 'Valor inválido.',
      required: 'O CNPJ é obrigatório',
      pattern: 'Este CNPJ é inválido.',
      maxlength: 'O CNPJ deve conter no máximo 14 caracteres.',
      validateCNPJ: 'Este CNPJ é inválido.',
      duplicate:
        'CNPJ já existe na base de dados. Verifique se o cadastro existente com esse dado esta correto.'
    },
    descricao: {
      required: 'A descrição é obrigatória',
      maxlength: 'A descrição deve conter até 100 caracteres',
      isEmptyValue: 'Inválido: remova os espaços em branco!'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<FastInstituicaoComponent>,
    private formBuilder: UntypedFormBuilder,
    public entityService: InstituicaoFinanceiraService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private data: { entity: IInstituicaoFinanceira }
  ) {}

  ngOnInit(): void {
    const { entity } = this.data;
    this.form = this.formBuilder.group({
      cnpj: [entity.cnpj, [Validators.required]],
      descricao: [
        entity.descricao,
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.form.controls.cnpj.valueChanges.subscribe(() => {
      this.validar();
    });
  }

  validar() {
    let cnpjValue = this.form.controls.cnpj.value;
    if (validateCnpj(cnpjValue)) {
      this.form.controls.cnpj.setErrors({ validateCNPJ: true });
      this.form.updateValueAndValidity();
    }
    // if (cpfCnpjValue.toString().length <= 11) {
    //   if (validateCpf(cpfCnpjValue)) {
    //     this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
    //     this.form.updateValueAndValidity();
    //   }
    // } else {
    //   if (validateCnpj(cpfCnpjValue)) {
    //     this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
    //     this.form.updateValueAndValidity();
    //   }
    // }
  }

  public checkCnpj(): void {
    const cnpj = this.form.controls.cnpj;

    if (cnpj.invalid) return;
    const cnpjValue: string = cnpj.value;

    this.entityService
      .getEntitiesByParams(
        `cnpj=${cnpjValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe((found: IInstituicaoFinanceira) => {
        if (found[0] && found[0].id) {
          cnpj.setErrors({ duplicate: true });
          this.form.updateValueAndValidity();
        }
      });
  }

  public submit(): void {
    if (!this.form.valid) return;

    this.loading = true;
    const { value } = this.form;
    const entity = {
      domain_org_id: this.tokenService.getDomain().id,
      ...value
    };
    this.entityService.insert(entity).subscribe(
      inst => {
        if (inst) {
          this.matSnackBar.open(`Instituição cadastrada com sucesso.`, 'X', {
            duration: 2000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['msg-success']
          });
          this.dialogRef.close(inst);
        }
      },
      () => {
        this.matSnackBar.open(`Erro ao cadastrar insituição.`, 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-error']
        });
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
}
